<template>
  <v-container 
    tag="section"
    fluid
  >
    <validation-observer ref="observer" slim v-slot="{ invalid }">
      <v-row align="center">
        <v-col cols="12">
          <v-container fluid tag="section">
            <base-material-card
              color="primary"
              icon="mdi-file-tree"
              inline
              class="px-5 py-4 ml-0"
            >
              <template v-slot:after-heading>
                <div class="display-2 font-weight-light">
                  {{ title }}
                </div>
              </template>
              <v-form class="mt-5">
                <v-row align="center" class="mx-auto">
                  <v-col cols="12">
                    <validation-provider v-slot="{ errors }" rules="required" id="titulo-grupos-arquivos">
                      <v-text-field
                        label="Título"
                        outlined
                        :error-messages="errors"
                        v-model="nome"
                      />
                    </validation-provider>
                  </v-col>
                </v-row>
              </v-form>
            </base-material-card>
          </v-container>
        </v-col>

        <v-col cols="12">
          <v-btn
            id="btn-save-grupos-arquivos"
            color="success"
            min-width="100"
            style="float: right;"
            :disabled="invalid"
            :loading="loading"
            @click="salvarGrupo()"
          >
            Salvar
          </v-btn>
        </v-col>
      </v-row>
    </validation-observer>
  </v-container>
</template>

<script>

import GruposArquivosService from '@/services/GruposArquivosService.js';

export default {
  name: "GruposArquivosEdit",

  data() {
    return {
      nome: "",
      loading: false,
    }
  },

  computed: {
    title() {
      return this.$route.params.id ? "Editando Grupo de Arquivos" : "Adicionar Grupo de Arquivos";
    },
    user() {
      return this.$store.getters.getUser;
    }
  },

  mounted() {
    if (this.$route.params.id) {
      this.getGrupoArquivos(this.$route.params.id);
    }
  },

  methods: {
    salvarGrupo() {
      const id = !this.$route.params.id ? null : this.$route.params.id;
      const postData = { 
        grupo: this.nome,
      };

      this.loading = true;

      GruposArquivosService.salvarGrupoArquivos(id, postData)
        .then(res => {
          this.$toast.success('Grupo de Arquivos salvo com sucesso.', '', { position:'topRight' });
          this.$router.push({ name: 'Grupos de Arquivos' });
        }).catch(err => {
          console.error(err);
          this.$toast.error('Erro ao salvar Grupo de Arquivos.', '', { position:'topRight' });
        })
        .finally(() => this.loading = false);
    },
    getGrupoArquivos(id) {
      GruposArquivosService.getGrupoArquivos(id)
        .then(res => {
          const data = res.data.grupo;
          this.nome = data.grupo;
        }).catch(err => {
          console.error(err);
          this.$toast.error('Erro ao recuperar Grupo de Arquivos.', '', { position:'topRight' });
          this.$router.push({ name: 'Grupos de Arquivos' });
        })
    },
  }
}

</script>

<style></style>